import { render, staticRenderFns } from "./AdminSettingsToggle.vue?vue&type=template&id=1a5d01f0&scoped=true"
import script from "./AdminSettingsToggle.vue?vue&type=script&lang=js"
export * from "./AdminSettingsToggle.vue?vue&type=script&lang=js"
import style0 from "./AdminSettingsToggle.vue?vue&type=style&index=0&id=1a5d01f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d01f0",
  null
  
)

export default component.exports